<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M3.75 12.75h16.5v8.5a2 2 0 0 1-2 2H5.75a2 2 0 0 1-2-2v-8.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.25 14.25h3M3.75 14.25h-3M3.75 12.75c0-3.314 3.694-4.5 8.25-4.5s8.25 1.186 8.25 4.5M14.25 18.75h1.5M12 5.25v3M18.75.75c1.437 2.873-2.151 2.381 0 5.25M5.206.75c1.437 2.873-2.151 2.381 0 5.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
